import useResource from "./useResource"

import { pluralize } from "web/services/inflector"

export default function useFieldValue({
  subjectType,
  topicId,
  recordId,
  fieldKey,
}) {
  var urlRoot

  if (!!topicId) {
    urlRoot = "/topics/records"
  } else if (["buyer", "lender", "investor"].includes(subjectType)) {
    urlRoot = "/deals/counterparties"
  } else {
    urlRoot = `/${pluralize(subjectType)}`
  }

  const key = `${urlRoot}/${recordId}/field_value/${fieldKey}`

  return useResource({ key })
}
